import { HelpButton } from '@components/help/HelpButton'
import { Localizable } from '@components/localizable/Localizable'
import Page from '@components/Page/Page'
import VenuesCollection from '@components/venuesCollection/VenuesCollection'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Flex, Space } from 'antd'

const NestedVenuesTab = () => {
  const venue = useAppSelector(selectSelectedVenue())

  if (!venue) {
    return <></>
  }

  return (
    <Localizable>
      <Page
        pageTitle={{
          title: 'Nested Venues',
          level: 5,
          toolbar: (
            <Space>
              <Localizable.LangSelector />
              <HelpButton articleId="53" />
              <SBRM.Actions
                actions={[SBRMAction.Create]}
                entity={Entity.venuesCollection}
                metadata={[{ key: MetadataKey.Venue, value: venue?.id }]}
              />
            </Space>
          ),
        }}
      >
        <Flex vertical gap={32}>
          <VenuesCollection.Card venueId={venue.id} />
        </Flex>
      </Page>
    </Localizable>
  )
}

export default NestedVenuesTab
